import {Dialog} from 'primereact'

import React from 'react'

export const DialogComponent = (props) => {
  const onHide = () => typeof props.onHide === 'function' && props.onHide()

  return (
    <Dialog 
      visible={true} 
      {...props} 
      className={'w-11 md:w-6 ' + (props.className || '')}
      style={{
        zIndex: 9999,
        top: '5%',
        ...props.style
      }}
      contentStyle={{
        maxHeight: '85vh',
        overflow: 'auto',
        ...props.contentStyle
      }}
    >
      {props.children}
    </Dialog>
  )
}
